import React from "react";
import { AvatarGroup } from "@mui/material";

import Avatar from "../../../../components/Avatar";
import { createAvatarName } from "../../../../utils";
import { getMyTaskHeadingLabel } from "../../utils/myTaskUtils";

function SelectUser({ user }) {
  return (
    <div className="d-flex align-items-center ">
      <div>
        <div className="cursor-pointer">
          <AvatarGroup max={4}>
            {user.map((el) => (
              <Avatar
                key={`user-avtar-${el?.first_name}-${el?.last_name}`}
                username={`${el.first_name} ${el.last_name}`}
                user_image={el.user_image}
                title={`${el.first_name} ${el.last_name}`}
                className="user-avtar-dropdown user-avatar"
                style={
                  !el.user_image && {
                    bgcolor: el?.profile_color?.background,
                    color: el?.profile_color?.text,
                  }
                }>
                {createAvatarName(`${el.first_name} ${el.last_name}` || "")}
              </Avatar>
            ))}
          </AvatarGroup>
        </div>
      </div>
      <div>
        <p className="board-heading-name">{getMyTaskHeadingLabel(user)}</p>
      </div>
    </div>
  );
}

export default SelectUser;
